var hasSymbol = typeof Symbol === 'function' && Symbol.for;
export default hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/ThemeProvider/nested.js
// module id = 446
// module chunks = 2